import React from 'react';
import FileBrowser from '@/components/efile/FileBrowser';
import { useAuth } from '@/context/AuthContext';

const FileWorkspace = () => {
  const { user } = useAuth();
  
  // Only higher authority can create folders
  const canCreateFolder = ['SuperAdmin', 'Admin', 'GM', 'Head'].includes(user?.role);

  return (
    <FileBrowser 
      apiEndpoint="/api/efile/active"
      pageTitle="File Workspace"
      pageDescription="Manage and organize your documents"
      userColumnLabel="Current Desk"
      defaultViewMode="grid"
      serverSideFiltering={false}
      showDeskSwitch={true}
      // Department Directory: Folders only at root.
      // Inside Folders: Files only.
      allowFileCreation={(folderId) => !!folderId}
      allowFolderCreation={(folderId) => !folderId && canCreateFolder}
    />
  );
};

export default FileWorkspace;
